import React, { useState } from "react";

// mui
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  CircularProgress,
} from "@mui/material";
import Slide from "@mui/material/Slide";
import TxtField from "../TxtField";
import SaveIcon from '@mui/icons-material/Upload';

// services
import { editServer } from "../../service/domain.service";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const blackListKey = ["id", "isBwLimited", "domains", "version"];

const EditDomain = ({ open, onClose, callback, server }) => {
  // state variables
  const [chnl, setChnl] = useState(server);
  const [_err, setErr] = useState(false);
  const [creating, setcreating] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setChnl({
      ...chnl,
      [name]: value,
    });
  };

  const _editChannel = async () => {
    setcreating(true);
    // let domains = chnl.domains.toString();
    // const splitted = domains.split(",");
    const toedit = {
      ...chnl,
    };
    const status = await editServer(toedit);
    if (status === "success") {
      setcreating(false);
      callback();
      return;
    } else {
      setErr("Error in saving changes");
      setcreating(false);
    }
  };

  const closeDialog = () => {
    setErr(false);
    setcreating(false);
    onClose();
  };

  React.useEffect(() => {
    setChnl(server);
  }, [server]);

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={closeDialog}
      aria-labelledby="create-channel-form"
    >
      <DialogTitle id="edit-channel-form-title">{"Edit Server"}</DialogTitle>
      <DialogContent>
        <DialogContentText id="edit-channel-form-title-description">
          {_err && <p style={{ color: "red" }}>Error in saving changes.</p>}
          {Object.keys(chnl)
            .filter((k) => blackListKey.indexOf(k) === -1)
            .map((k) => (
              <TxtField
                id={k}
                name={k}
                label={k}
                value={chnl[k]}
                disabled={creating || k === "current_ip" || k === "name"}
                onChange={handleChange}
              />
            ))}
        </DialogContentText>
        {creating && (
          <div style={{ display: "flex", justifyContent: "center" }}>
            <CircularProgress />
          </div>
        )}
      </DialogContent>
      <DialogActions>
        <Button
          onClick={_editChannel}
          variant="contained"
          color="success"
          disableElevation
          disabled={creating}
          startIcon={<SaveIcon />}
          sx={{ textTransform: "none" }}
        >
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EditDomain;
